import React, { useEffect, useState } from "react";
import $ from "jquery";
import "jquery-ui-dist/jquery-ui";
import "jquery-ui-dist/jquery-ui.css";
import { GetCities } from "../../Services/API";
import { RaisebusEnquiry } from "../../Services/EnquiryApi"

const BusSearch = () => {

  const [pickUpLocationSuggestions, setPickUpLocationSuggestions] = useState([]);
  const [dropLocationSuggestions, setDropLocationSuggestions] = useState([]);
  const [errors, setErrors] = useState({});
  const [showPopup, setShowPopup] = useState(false);
  const [enquiryMessage, setEnquiryMessage] = useState("");
  const [enquiryStatus, setEnquiryStatus] = useState(false);
  const [busSearchParams, setBusSearchParams] = useState({

    travelType: "",
    from: "",
    to: "",
    travelDate: "",
    returnDate: "",
    adult: 1,
    child: 0,
    infant: 0,
  });

  const swapMainDestination = (e) => {
    e.preventDefault();

    setBusSearchParams((prev) => ({
      ...prev,
      from: prev.to,
      to: prev.from,
    }));
  };

  // FETCH From SUGGESTIONS
  const handleFromLocation = async (e) => {
    const value = e.target.value;
    if (value.length > 2) {
      const data = await GetCities(value);
      setPickUpLocationSuggestions(data?.cities || []);
    } else {
      setPickUpLocationSuggestions([]);
    }
  };


  // FETCH To SUGGESTIONS
  const handleToLocation = async (e) => {
    const value = e.target.value;
    if (value.length > 2) {
      const data = await GetCities(value);
      setDropLocationSuggestions(data?.cities || []);
    } else {
      setDropLocationSuggestions([]);
    }
  };

  // SELECT PICKUP CITY
  const selectFromLocation = (city) => {
    const location = `${city.cityName} - ${city.countryName}`;

    setBusSearchParams((prev) => ({
      ...prev,
      from: location,
    }));

    setPickUpLocationSuggestions([]);
  };

  // SELECT DROP CITY
  const selectToLocation = (city) => {
    const location = `${city.cityName} - ${city.countryName}`;

    setBusSearchParams((prev) => ({
      ...prev,
      to: location,
    }));

    setDropLocationSuggestions([]);
  };

  // HANDLE INPUT CHANGES
  const handleChange = (e) => {
    const { name, value } = e.target;
    setBusSearchParams((prev) => ({ ...prev, [name]: value }));
  };


  useEffect(() => {
    $("#departureDate").datepicker({
      dateFormat: "dd/mm/yy",
      appendTo: "#dateDisplay",
      minDate: 0,
      maxDate: "+4m", // ✅ limit 4 months ahead
      showAnim: "fadeIn",
      beforeShow: function (input, inst) {
        setTimeout(() => {
          const offset = $("#dateDisplay").offset();
          const height = $("#dateDisplay").outerHeight();
          $(inst.dpDiv).css({
            top: offset.top + height + "px",
            left: offset.left + "px",
          });
        }, 0);
      },
      onSelect: function (fromDate) {
        const date = $(this).datepicker("getDate");
        const day = ("0" + date.getDate()).slice(-2);
        const month = date.toLocaleString("default", { month: "short" });
        const year = date.getFullYear();
        const dayName = date.toLocaleDateString("default", { weekday: "long" });

        $("#dep_dayNum").text(day);
        $("#dep_monthYear").text(`${month}-${year}`);
        $("#dep_dayName").text(dayName);

        setBusSearchParams(prev => ({
          ...prev,
          travelDate: fromDate
        }));
      },
    });
  }, []);

  useEffect(() => {
    $("#returnDate").datepicker({
      dateFormat: "dd/mm/yy",
      appendTo: "#dateDisplay2",
      minDate: 0,
      maxDate: "+4m",
      showAnim: "fadeIn",
      beforeShow: function (input, inst) {
        setTimeout(() => {
          const offset = $("#dateDisplay2").offset();
          const height = $("#dateDisplay2").outerHeight();
          $(inst.dpDiv).css({
            top: offset.top + height + "px",
            left: offset.left + "px",
          });
        }, 0);
      },
      onSelect: function (toDate) {
        const date = $(this).datepicker("getDate");
        const day = ("0" + date.getDate()).slice(-2);
        const month = date.toLocaleString("default", { month: "short" });
        const year = date.getFullYear();
        const dayName = date.toLocaleDateString("default", { weekday: "long" });

        $("#ret_dayNum").text(day);
        $("#ret_monthYear").text(`${month}-${year}`);
        $("#ret_dayName").text(dayName);
        setBusSearchParams(prev => ({
          ...prev,
          returnDate: toDate
        }));
      },
    });
  }, []);

  const convertToDate = (str) => {
    if (!str) return null;
    const [day, month, year] = str.split("/");
    return new Date(`${year}-${month}-${day}`);
  };

  useEffect(() => {
    if (busSearchParams.travelDate) {
      const minD = convertToDate(busSearchParams.travelDate);
      $("#returnDate").datepicker("option", "minDate", minD);
    }
  }, [busSearchParams.travelDate]);

  const handleRaiseRequest = async () => {
    let newErrors = {};

    if (!busSearchParams.from.trim()) {
      newErrors.from = "Please select a From location";
    }
    if (!busSearchParams.to.trim()) {
      newErrors.to = "Please select a To location";
    }

    if (!busSearchParams.travelDate.trim()) {
      newErrors.FromDate = "Please select Travel Date";
    } else {
      // const datePattern = /^\d{2}\/\d{2}\/\d{4}$/;
      // if (!datePattern.test(cabSearchParams.fromDate)) {
      //   newErrors.date = "Date must be in dd/mm/yyyy format";
      // }
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setErrors({});

    const requestBody = {
      TravelType: busSearchParams.travelType,
      From: busSearchParams.from,
      To: busSearchParams.to,
      TravelDate: busSearchParams.travelDate,
      ReturnDate: busSearchParams.returnDate,
      noOfAdult: busSearchParams.adult,
      noOfChild: busSearchParams.child,
      noOfInfant: busSearchParams.infant,
      CompanyId: "B2343",
      CreatedBy: "BerryJourneys"
    };

    try {
      const result = await RaisebusEnquiry(requestBody);
      if (result.success) {
        setEnquiryMessage(result.message)
        setEnquiryStatus(true);
      }
      else {
        setEnquiryMessage(result.message)
      }
      setShowPopup(true);
    } catch {
      alert("Failed to submit enquiry");
    }
  };

  return (
    <>
      <div className='bus_serch'>
        <div className='row'>
          <div className='col-md-6 col-lg-6'>
            <div className='d-flex'>
              <div className="travel_mode">
                <div className="form-check form-check-custom form-check-solid">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="travelType"
                    value="BusinessTravel"
                    onChange={handleChange}
                  />
                  <label className="form-check-label" htmlFor="BusinessTravel">
                    Business Travel
                  </label>
                </div>
              </div>

              <div className="travel_mode">
                <div className="form-check form-check-custom form-check-solid">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="travelType"
                    value="PersonalTravel"
                    onChange={handleChange}
                  />
                  <label className="form-check-label" htmlFor="PersonalTravel">
                    Personal Travel
                  </label>
                </div>
              </div>

              <div className="travel_mode">
                <div className="form-check form-check-custom form-check-solid">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="travelType"
                    value="GuestTravel"
                    onChange={handleChange}
                  />
                  <label className="form-check-label" htmlFor="GuestTravel">
                    Guest Travel
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className='col-md-6 col-lg-6'>
            <div className='theme_tx'>
              {/* <h3>Book Bus Tickets Online !</h3> */}
            </div>
          </div>
        </div>

        <div className='form_ful'>
          <div className='s_col_1'>
            <div className='bus_icon_img'>
              <img className='bus_ic' src='/assets/images/bus/bus.png' />
            </div>
            <div className='bus_icon'>
              <p>From</p>
              {/* <label> From</label> */}
              <input
                type="text"
                className="pick_form"
                name="from"
                placeholder="Enter City.."
                value={busSearchParams.from}
                onChange={(e) => {
                  handleChange(e);           // updates state
                  handleFromLocation(e);  // fetches suggestions
                }}
              />
              {pickUpLocationSuggestions.length > 0 && (
               <ul className="autosuggetsList">
                  {pickUpLocationSuggestions.map((city, index) => (
                    <li key={index} onClick={() => selectFromLocation(city)}>
                      {city.cityName} - {city.countryName}
                    </li>
                  ))}
                </ul>
              )}
              {errors.from && <p className="error_mes">{errors.from}</p>}
            </div>
            <a href="" class="swiper_bus" onClick={swapMainDestination}> <img alt="icon" src="/assets/images/swipe.png" /> </a>
          </div>
          <div className='s_col_1'>
            <div className='bus_icon_img'>
              <img className='bus_ic' src='/assets/images/bus/bus.png' />
            </div>
            <div className='bus_icon'>
              <p>To</p>
              <input
                type="text"
                className="pick_form"
                name="to"
                placeholder="Enter City.."
                value={busSearchParams.to}
                onChange={(e) => {
                  handleChange(e);           // updates state
                  handleToLocation(e);  // fetches suggestions
                }}
              />
              {dropLocationSuggestions.length > 0 && (
                <ul className="autosuggetsList">
                  {dropLocationSuggestions.map((city, index) => (
                    <li key={index} onClick={() => selectToLocation(city)}>
                      {city.cityName} - {city.countryName}
                    </li>
                  ))}
                </ul>
              )}

              {errors.to && <p className="error_mes">{errors.to}</p>}
              {/* <div className='dest_nam'>Delhi</div>
              <p className='area_nm'>india</p> */}
            </div>
          </div>
          <div className='s_col_1 date_bssc'>
            <div className='bus_icon_img'>
              <img className='bus_ic' src='/assets/images/bus/date.png' />
            </div>
            <div className='bus_icon'>
              <p>Travel Date</p>
              <div
                className="dest_nam"
                id="dateDisplay"
                onClick={() => $("#departureDate").datepicker("show")}
                style={{ cursor: "pointer" }}
              >
                <span id="dep_dayNum" style={{ fontSize: "28px", fontWeight: "bold" }}>
                  DD
                </span>{" "}
                <span id="dep_monthYear" style={{ fontSize: "14px" }}>
                  MMM-YYYY
                </span>
                <br />
                <span id="dep_dayName">
                  Day
                </span>
                <input
                  type="text"
                  id="departureDate"
                  style={{ position: "absolute", left: "-9999px" }}
                  readOnly
                />
              </div>
              {errors.FromDate && <p className="error_mes">{errors.FromDate}</p>}
            </div>
          </div>
          <div className='s_col_1 date_bssc'>
            <div className='bus_icon_img'>
              <img className='bus_ic' src='/assets/images/bus/date.png' />
            </div>
            <div className='bus_icon'>
              <p>Return Date</p>
              <div
                className="dest_nam"
                id="dateDisplay2"
                onClick={() => $("#returnDate").datepicker("show")}
                style={{ cursor: "pointer" }}
              >
                <span id="ret_dayNum" style={{ fontSize: "28px", fontWeight: "bold" }}>
                  DD
                </span>{" "}
                <span id="ret_monthYear" style={{ fontSize: "14px" }}>
                  MMM-YYYY
                </span>
                <br />
                <span id="ret_dayName">
                  Day
                </span>
                <input
                  type="text"
                  id="returnDate"
                  style={{ position: "absolute", left: "-9999px" }}
                  readOnly
                />
              </div>
              {errors.ToDate && <p className="error_mes">{errors.ToDate}</p>}
            </div>
          </div>

          <div className='Rooms_Guests_Serch'>
            <button className="Serch" onClick={handleRaiseRequest} type="button">
              Raise Request
            </button>
          </div>
        </div>
      </div>

      {showPopup && (
        <div className="popup-overlay" onClick={() => setShowPopup(false)}>
          <div className="popup-box" onClick={(e) => e.stopPropagation()}>
            <h3>{enquiryMessage}</h3>
            <button
              onClick={() => {
                setShowPopup(false);
                window.location.reload();
              }}
              className="btn btn-primary"
            >
              Ok
            </button>
          </div>
        </div>
      )}
    </>

  );
};

export default BusSearch;
